import { post , get } from '../axiosconfig'
import qs from 'qs'
export default {

  /******************** 算力市场 ********************/
  // 获取用户信息
  getUserInfo(params){
    params = qs.stringify(params)
    return get('/api/user', params)
  },
  // 单卡 - 算力配置
  powerConfig(params) {
    params = qs.stringify(params);
    return get('/zsc/web/power/config', params)
  },
  // 单卡 - 机器列表
  powerlist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/power/list', params)
  },

  // 整机 - 算力配置
  machineConfig(params) {
    params = qs.stringify(params);
    return get('/zsc/web/machine/config', params)
  },

  // 整机 - 机器列表
  machinelist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/machine/list', params)
  },

  // 订单预览
  powerPreview(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/order/preview', params)
  },
  // 基础镜像
  getMirrorlist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/image/list', params)
  },
  // 创建订单
  createOrderIndex(params) {
    return post('/zsc/web/console/order/create', params)
  },
  // 订单支付
  payApply(params) {
    return post('/zsc/web/console/pay/apply', params)
  },

  /******************** 算力中心 - 概览 ********************/
  // 账户信息
  getSlOverview(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/account/info', params)
  },
  getPointlog(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/user/hash_bean_log', params)
  },

  /******************** 算力中心 - 容器实例 ********************/
  // 基础实例列表
  getContainerlist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/container/list', params)
  },
  // 应用实例列表
  getStudiolist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/studio/list', params)
  },

  // 容器配置
  containerUpdate(params) {
    return post('/zsc/web/console/container/update', params)
  },

  // 获取 SSH
  getSSHcommand(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/container/access_ssh_command', params)
  },
  // jupyterUrl
  getAccessJupyterUrl(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/container/access_jupyter_url', params)
  },

  // 导出容器列表
  getDataExport(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/container/data_export', params)
  },

  // 容器管理
  containerApply(params) {
    return post('/zsc/web/console/container/apply', params)
  },

  // 容器管理 订单类型 [1:产品新购,2:容器续费,3:容器升级,4:容器降级,5:容器转包年包月,6:容器克隆,7:容器数据盘扩容,8:容器数据盘缩容,9:容器云盘扩容,10:容器云盘续费]
  previewOrder(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/order/preview', params)
  },

  // 容器管理 订单类型 [1:产品新购,2:容器续费,3:容器升级,4:容器降级,5:容器转包年包月,6:容器克隆,7:容器数据盘扩容,8:容器数据盘缩容,9:容器云盘扩容,10:容器云盘续费]
  createOrderContainer(params) {
    return post('/zsc/web/console/order/create', params)
  },
  // 实例监控
  getMonitorInfo(params) {
    return post('/zsc/web/console/container/monitor', params)
  },

  // 云盘挂载
  setDiskMount(params) {
    return post('/zsc/web/console/disk/mount', params)
  },
  // 云盘卸载
  setDiskUnmount(params) {
    return post('/zsc/web/console/disk/unmount', params)
  },

  transferSubaccount(params) {
    return post('/zsc/web/console/container/transfer', params)
  },

  /******************** 算力中心 - 镜像 ********************/
  // 基础列表
  getImagelist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/image/list', params)
  },

  // 应用列表
  getImageApplylist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/image/studios', params)
  },

  // 应用详情
  // image_id integer 
  getImageApplyDetail(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/image/studio', params)
  },

  // 镜像更新
  imageUpdate(params) {
    return post('/zsc/web/console/image/update', params)
  },
  // 镜像共享
  imageShare(params) {
    return post('/zsc/web/console/image/share/create', params)
  },
  // 镜像删除
  imageDelete(params) {
    return post('/zsc/web/console/image/remove', params)
  },
  // 镜像分享列表
  shareUserlist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/image/share/list', params)
  },
  // 镜像共享移除
  imageRemove(params) {
    return post('/zsc/web/console/image/share/remove', params)
  },

  /******************** 算力中心 - 云盘 ********************/
  //云盘更新
  cloudDiskUpdate(params) {
    return post('/zsc/web/console/cloud_disk/update', params)
  },
  //云盘共享
  cloudDiskShare(params) {
    return post('/zsc/web/console/cloud_disk/share', params)
  },
  //云盘删除
  cloudDiskDelete(params) {
    return post('/zsc/web/console/cloud_disk/delete', params)
  },

  /******************** 算力中心 - 公开数据 ********************/
  /******************** 算力中心 - 概览数据 ********************/
  //概览信息
  getStats(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/account/stats',params)
  },
  //到期释放预警
  geteWarnnable(params){
    return post('/zsc/web/console/account/update', params)
  },
  // 帮助中心
  getHelplist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/help/list',params)
  },
  // 分享链接
  shareCode(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/user/share',params)
  },
  // 链接提示
  shareInfo(params) {
    params = qs.stringify(params);
    return get('/zsc/web/activity/share/info',params)
  },

  /******************** 算力中心 - 文件存储 ********************/
  // 已挂载 - 基础列表数据
  getCloudDiskMounted(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/disk/list', params)
  },
  // 未挂载 - 实例Select
  getCloudDiskUnmounted(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/container/cloud_disk_unmounted', params)
  },
  // 订单 - 预览
  getPreviewOrder(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/order/preview', params)
  },
  // 订单 - 创建
  createOrderFile(params) {
    return post('/zsc/web/console/order/create', params)
  },

  // 我的优惠券
  getCouponlist(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/coupon/list', params)
  },

  // 确认邀请福利类型
  selectTkType(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/user/share/rankings', params)
  },

  // 邀请活动月排行榜
  monthlyRanking(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/user/share/rankings', params)
  },
  // 邀请用户列表
  inviteUserList(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/user/share/status', params)
  },
  // 主机续费订单预览
  hostRenewalOrderPreview(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/order/preview', params)
  },
  // 主机续费
  hostOrderCreation(params) {
    return post('/zsc/web/console/order/create', params)
  },
  // 主机列表
  hostList(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/machine/list', params)
  },
  // 主机分配
  hostAllocation(params) {
    return post('/zsc/web/console/container/allot', params)
  },
  // 主机详情
  getMachineInfo(params) {
    params = qs.stringify(params);
    return get('/zsc/web/console/machine/info', params)
  },
  // 主机释放
  machineApply(params) {
    return post('/zsc/web/console/machine/apply', params)
  },

  // 实例续费
  containerAutoRenew(params) {
    return post('/zsc/web/console/container/update', params)
  },

  // 主机续费
  machineAutoRenew(params) {
    return post('/zsc/web/console/machine/update', params)
  },



}



// WEBPACK FOOTER //
// ./src/api/public/sl_api.js